import React, { Component } from "react";
import Slider from "react-slick";
import EventGalleryCard from './EventGalleryCard';
import { createGlobalStyle } from "styled-components";

const CarouselStyleComponent = createGlobalStyle`
.wrapper .slick-next:before,
.wrapper .slick-prev:before{
  color: #212121;
}

`
function ImgOrVideoCards(props) {
    const { items, active } = props;
    const settings = {
      dots: true,
      infinite: false,
      speed: 500,
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: true,
      responsive: [
        {
          breakpoint: 800,
          settings: {
            slidesToShow: 2,
            centerMode: true,
            initialSlide : 1,
            arrows: false,
            slidesToScroll: 1,
            swipeToSlide: true,
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            centerMode: true,
            initialSlide : 0,
            arrows: false,
            slidesToScroll: 1,
            swipeToSlide: true,
          }
        },
      ]
    };
  
      return (  
        <div style={{padding: '0px 35px'}} className='wrapper'>
          <CarouselStyleComponent />
          <Slider {...settings}>
            {items && items.length > 0 && items.map((item, index) => 
                <React.Fragment key={index}>
                  <EventGalleryCard item={item} items={items} index={index} active={active} />
                </React.Fragment>
              ) }
          </Slider>
        </div>
      );
    }


export default ImgOrVideoCards;
